/* =================== MODAL =================== */

// Abre o modal
function openModal(modal) {
  $("body").css("overflow", "hidden");
  $("#" + modal).addClass("open");
  $("#" + modal).trigger("modal-open");
}

// Fecha o modal
function closeModal(modal) {
  $("body").css("overflow", "auto");
  $("#" + modal).removeClass("open");
  $("#" + modal).trigger("modal-close");
}

// Abre o modal de alerta
function showAlert(titulo, mensagem, tipo) {
  $("#modal-alert").removeClass("success warning error");
  $("#modal-alert").addClass(tipo);
  $("#alert-titulo").text(titulo);
  $("#alert-texto").html(mensagem);
  openModal("modal-alert");
}

$(function () {
  // Abre o modal ao clicar no botão
  $(".modal-open").on("click", function (e) {
    e.preventDefault();
    openModal($(this).data("modal"));
  });

  // Fecha o modal ao clicar no botão
  $(".modal-close").on("click", function (e) {
    e.preventDefault();
    closeModal($(this).data("modal"));
  });

  // Fecha o modal ao clicar em qualquer outro lugar da tela
  $(".modal").on("click", function (e) {
    if (e.target == this && !$(this).hasClass("modal-force")) {
      closeModal($(this).attr("id"));
    }
  });

  // Fecha o modal ao pressionar a tecla ESC
  $(document).on("keyup", function (e) {
    if (e.keyCode == 27) {
      $(".modal.open")
        .not(".modal-force")
        .each(function () {
          closeModal($(this).attr("id"));
        });
    }
  });
});

// ------------------------------------
// Exibe o vídeo
// ------------------------------------
(function () {
  "use strict";

  const $modalVideo = $("#modal-video-box");
  const $btnOpenVideo = $(".btn-open-video");

  // Exibe o modal do vídeo ao clicar no botão
  $btnOpenVideo.on("click", function (ev) {
    ev.preventDefault();
    const $btn = $(this);
    const videoCod = $btn.data("video-cod");
    const videoPlataform = $btn.data("video-plataform");
    const videoTitle = $btn.data("video-title");
    if (videoCod != "" && videoPlataform != "" && !$btn.hasClass("disabled")) {
      $modalVideo
        .find(".bloco-video-wrapper")
        .html("")
        .append(createIframeVideo(videoCod, videoPlataform));
      if (videoTitle != "") {
        $modalVideo.find(".bloco-video-titulo").html(videoTitle).show();
      } else {
        $modalVideo.find(".bloco-video-titulo").html("").hide();
      }
      openModal("modal-video-box");
    }
  });

  // Remove o vídeo ao fechar o modal
  $modalVideo.on("modal-close", function () {
    $modalVideo.find(".bloco-video-wrapper").html("");
    $modalVideo.find(".bloco-video-titulo").html("").hide();
  });

  // Cria um elemento Iframe de vídeo
  function createIframeVideo(videoCod, videoPlataform) {
    let $iframe;
    if (videoPlataform == "youtube") {
      $iframe = `<iframe src="https://www.youtube.com/embed/${videoCod}?controls=1&autoplay=1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>`;
    } else if (videoPlataform == "vimeo") {
      $iframe = `<iframe src="https://player.vimeo.com/video/${videoCod}?title=0&byline=0&portrait=0&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
    }
    return $iframe;
  }
})();
